import { Injectable, inject } from '@angular/core';
import { DeviceType, LegacyPermissionType } from 'shared-states';
import { NavigationTarget } from '../../navigation-target';
import { LegacyRoutes } from '../../portal-routes';
import { PortalUrls } from '../../portal-urls.service';
import { LandingContext, LandingRule } from '../landing-rule';

const MOBILE_DEVICES: readonly DeviceType[] = [DeviceType.Mobile, DeviceType.Tablet];

/** On mobile devices users allowed to order work in the mobile basket. */
@Injectable({ providedIn: 'root' })
export class MobileBasketLandingRule implements LandingRule {
  private readonly urls = inject(PortalUrls);

  resolve({ deviceType, selectedOrganization }: LandingContext): NavigationTarget | null {
    const isMobile = !!deviceType && MOBILE_DEVICES.includes(deviceType);
    const canOrder = !!selectedOrganization?.permissions.legacyPermissions.includes(LegacyPermissionType.ShowRequestAndOrder);
    return isMobile && canOrder ? NavigationTarget.external(this.urls.legacyPortal(LegacyRoutes.mobileBasket)) : null;
  }
}
